import { render, staticRenderFns } from "./homeShebeilist.vue?vue&type=template&id=1545e4ca&scoped=true&"
import script from "./homeShebeilist.vue?vue&type=script&lang=js&"
export * from "./homeShebeilist.vue?vue&type=script&lang=js&"
import style0 from "./homeShebeilist.vue?vue&type=style&index=0&id=1545e4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1545e4ca",
  null
  
)

export default component.exports